import { OverlayShellConfig } from "../../../shared/overlay-shell/overlay.models";

export const EDIT_SICKNESS_OVERLAY_CONFIG: OverlayShellConfig = {
  resizable: false,
  width: "auto",
  height: "auto",
};
